import { IconNames } from '@shipengine/giger-theme';
import { getChipStyles, getChipButtonStyles } from './ChipStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Icon } from '../Icon/Icon.js';
import { IconSize } from '../Icon/types/size.js';

const Chip = _ref => {
  let {
    children,
    isSelected,
    tabIndex = 0,
    onRemove,
    onSelect,
    onClick,
    ...rest
  } = _ref;
  const onRemoveHandler = e => {
    e.stopPropagation();
    onRemove === null || onRemove === void 0 ? void 0 : onRemove(e);
  };
  const onClickHandler = e => {
    e.stopPropagation();

    // onClick will be removed with the next Breaking change
    onClick === null || onClick === void 0 ? void 0 : onClick(e, tabIndex);
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(tabIndex);
  };
  const onKeyUp = e => {
    if (e.code !== 'Enter') {
      return;
    }
    e.stopPropagation();
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(tabIndex);
  };
  return jsxs("span", {
    role: "tab",
    onClick: onClickHandler,
    onKeyUp: onKeyUp,
    "aria-selected": isSelected,
    tabIndex: tabIndex,
    css: getChipStyles(isSelected, !!onRemove),
    ...rest,
    children: [children, onRemove && jsx("button", {
      css: getChipButtonStyles,
      type: "button",
      onClick: onRemoveHandler,
      "data-id": "close-button",
      children: jsx(Icon, {
        name: IconNames.CLOSE,
        size: IconSize.SIZE_SMALL
      })
    })]
  });
};

export { Chip };
//# sourceMappingURL=Chip.js.map
